import { getUserGroupFromToken } from './util';

export interface ServiceInfo {
  name: string;
  imageUrl: string;
  siteUrl: string;
}
const getAllowedServices = () => {
  const serviceUrls = SERVICES.map((s) => s.siteUrl);
  return {
    superadmin: serviceUrls,
    admin: serviceUrls.filter(
      (service) =>
        service !== '/orderlord/' && service !== '/doc/' && service !== '/transport-admin/'
    ),
    ecom: [
      '/restriktioner/',
      '/redirector/',
      '/item-merchandiser/',
      '/apotekshanteraren/',
      '/se-produkt/',
      '/historian/',
    ],
    warehouse: ['/boka-transport/', '/apotekshanteraren/', '/se-produkt/'],
    'customer-service': [
      '/restriktioner/',
      '/skicka-sms/',
      '/retur/',
      '/apotekshanteraren/',
      '/se-produkt/',
      '/order-monitoring/',
      '/paketportalen/',
      '/historian/',
    ],
    'warehouse-admin': [
      '/boka-transport/',
      '/apotekshanteraren/',
      '/se-produkt/',
      '/transport-admin/',
    ],
    pharmacy: [
      '/apotekssidan/',
      '/skicka-sms/',
      '/paketportalen/',
      '/apotekshanteraren/',
      '/se-produkt/',
    ],
    'mh-pharmacy': ['/mathem/'],
  } as const;
};
export const filterAllowedServices = (accessToken?: string): ServiceInfo[] => {
  const allowedServices = getAllowedServices();
  const groups = getUserGroupFromToken(accessToken) as (keyof typeof allowedServices)[];
  const uniqueValues = new Set(groups.map((g) => allowedServices[g]).flat());
  return SERVICES.filter((service) => uniqueValues.has(service.siteUrl));
};
export const SERVICES = [
  {
    name: 'Skicka SMS',
    imageUrl: '/images/sms_service.svg',
    siteUrl: '/skicka-sms/',
  },
  {
    name: 'Paketportalen',
    imageUrl: '/images/web_order_portal.svg',
    siteUrl: '/paketportalen/',
  },
  {
    name: 'Göra retur',
    imageUrl: '/images/return_service.svg',
    siteUrl: '/retur/',
  },
  {
    name: 'Ordermonitorering',
    imageUrl: '/images/order-monitoring.png',
    siteUrl: '/order-monitoring/',
  },
  {
    name: 'Restriktioner',
    imageUrl: '/images/Order_monitioring.svg',
    siteUrl: '/restriktioner/',
  },
  {
    name: 'Orderlord',
    imageUrl: '/images/orderlord.png',
    siteUrl: '/orderlord/',
  },
  {
    name: 'Apotekssidan',
    imageUrl: '/images/anvandarhantering.svg',
    siteUrl: '/apotekssidan/',
  },
  {
    name: 'Boka transport',
    imageUrl: '/images/boka_transport.svg',
    siteUrl: '/boka-transport/',
  },
  {
    name: 'Redirector',
    imageUrl: '/images/redirector.png',
    siteUrl: '/redirector/',
  },
  {
    name: 'Item merchandiser',
    imageUrl: '/images/ranking.png',
    siteUrl: '/item-merchandiser/',
  },
  {
    name: 'Transport Dashboard',
    imageUrl: '/images/dashboard.svg',
    siteUrl: '/transport-dashboard/',
  },
  {
    name: 'Apotekshanteraren',
    imageUrl: '/images/apotekshanteraren.svg',
    siteUrl: '/apotekshanteraren/',
  },
  {
    name: 'Transport Admin',
    imageUrl: '/images/transportadmin.png',
    siteUrl: '/transport-admin/',
  },
  {
    name: 'Se Produkt',
    imageUrl: '/images/see-product.png',
    siteUrl: '/se-produkt/',
  },
  {
    name: 'Historian',
    imageUrl: '/images/historian.png',
    siteUrl: '/historian/',
  },
];
